/* tslint:disable */
/* eslint-disable */
export enum RegionType {
  Eastern = 'Eastern',
  Western = 'Western',
  Midwest = 'Midwest',
  Southern = 'Southern'
}
